/* Included in grunt file */
var memberModule = memberModule || {};
memberModule.application = {};
memberModule.application.creditCardOptions = [];
memberModule.init = function() {
	var $member = $('#member');
	var $application = $member.find('form.application');

	if ($application.length) {
		$member.find('#paymentType').change(function () {
			$member.find('fieldset.payment .elm').not('#elm_paymentType').toggle($.inArray($(this).val(), memberModule.application.creditCardOptions) != -1);
		}).trigger('change');

		$member.find('input[name=give]:radio').change(function () {
			if($(this).is(':checked')) {
				$member.find('fieldset.give-info .elm').not('#elm_give').toggle($(this).val() == 'yes');
			}
			window.dispatchEvent(new Event('resize'));
		}).trigger('change');

		$member.find('input[name=paymentRepeated]:radio').change(function () {
			if($(this).is(':checked') && $member.find('#elm_paymentRepeated').is(':visible')) {
				$member.find('#elm_splitPayment').toggle($(this).val() == 'yes');
			}
		}).trigger('change');
	}
};
